import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { NetworkCallService } from '../../core/services/network-call.service';
import * as fromTodoActions from '../../features/todos/actions';
import { ISetupStatusResponse } from '../../features/todos/models/setup-status.model';
import { EMPTY_GUID } from '../constants';

/**
 * Effect for loadRegulationVerified so it runs on all routes (e.g. on reload
 * when user is on entity-dashboard). Registered in SharedModule so it is
 * active wherever SharedModule is imported (e.g. AppModule).
 */
@Injectable()
export class RegulationVerifiedEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService
  ) {}

  loadRegulationVerified$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTodoActions.loadRegulationVerified),
      switchMap(action => {
        if (!this.isValidBusinessId(action.businessId)) {
          return EMPTY;
        }

        return this.networkCallService
            .get<ISetupStatusResponse>(`Business/${action.businessId}/SetupStatus`)
            .pipe(
              map(response => fromTodoActions.loadRegulationVerifiedSuccess({ response })),
              catchError(error => of(fromTodoActions.loadRegulationVerifiedFailure(error)))
            );
      })
    )
  );

  private isValidBusinessId(businessId: string | null | undefined): boolean {
    const id = businessId?.trim().toLowerCase();
    return !!id && id !== 'null' && id !== 'undefined' && id !== EMPTY_GUID;
  }
}
